import api from '../callApi';

function mapRepresentativeResponse(json) {
    if (!json) return null;
    return {
        representative: [...json]
    };
}

async function getCivicData(geoCodeData, representativeSearch) {
    const url = `Localization/GetRepresentatives`;
    const numToFetch = geoCodeData.addresses.length > 1 ? 2 : 1;
    let result;
    for (let i = 0; i < numToFetch; i++) {
        const address = geoCodeData.addresses[i];
        const data = {
            representativeSearch,
            state: address.state,
            district: address.district,
            address: address.address
        };

        result = await api.post(url, data).then(json => {
            let representativeResponse = mapRepresentativeResponse(json);
            if (representativeResponse == null) return Promise.reject();

            return {
                ...representativeResponse,
                ...address
            };
        });

        const returnedLevels = [...new Set(result.representative.map(r => r.level))];
        const allRequestedRepsIncluded = representativeSearch.levels.every(
            l => returnedLevels.indexOf(l) !== -1
        );
        if (allRequestedRepsIncluded) {
            return result;
        }
    }
    return result;
}

export default getCivicData;
